const state = {
    databases: [],
    database_users: [],
    users_to_databases_links: [],
    database_systems: [],
    database_global_locations: [],
};

const getters = {
};

const actions = {
    GetDomainDatabases({commit}, request_data)
    {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route('environments.get_databases', {
                domain_id: request_data['domain_id']
            });

            this._vm.$axios.get(r, request_data)
                .then(response => {
                    if (response.data.call_status === "OK")
                    {
                        resolve(response.data);
                    }
                    else
                    {
                        reject(response.data.error);
                    }
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {

                });
        });
    },

    LoadDatabasesData({ commit}, request_data ) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route('databases.load_database_data', {
                domain_id: request_data['domain_id'],
            });
            this._vm.$axios.get(r, request_data)
                .then(response => {
                    if(!response.data.call_status) {
                        reject('Response data error');
                    } else if (response.data.call_status === "OK") {
                        commit("setDatabases", response.data.data.databases.reverse());
                        commit("setDatabaseUsers", response.data.data.database_users);
                        commit("setUsersToDatabasesLinks", response.data.data.users_to_databases_links);
                        commit("setDatabaseSystems", response.data.data.database_systems);
                        commit("setDatabaseGlobalLocations", response.data.data.database_global_locations);

                        resolve();
                    } else {
                        reject(response.data.error);
                    }
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {

                });
        });
    },

    GetDatabaseSystemsForDomain({ commit }, payload) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route("environments.get_db_systems", { domain_id: payload.domain_id });
            this._vm.$axios
                .get(r)
                .then((response) => {
                    if(!response.data.call_status) {
                        reject('Response data error');
                    } else if (response.data.call_status === "OK") {
                        resolve(response.data.data);
                    } else {
                        reject(response.data.error);
                    }
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {});
        });
    },

    GetDatabaseUserPassword({ commit}, request_data ) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route('databases.get_database_user_password', {
                domain_id: request_data['domain_id'],
                user_id: request_data['database_user_id'],
            });
            this._vm.$axios.get(r, request_data)
                .then(response => {
                    if(!response.data.call_status) {
                        reject('Response data error');
                    } else if (response.data.call_status === "OK") {
                        resolve(response.data.data);
                    } else {
                        reject(response.data.error);
                    }
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {

                });
        });
    },

    AddDatabase({ commit}, request_data ) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route('databases.add_database', {
                domain_id: request_data['domain_id'],
            });
            this._vm.$axios.post(r, request_data)
                .then(response => {
                    if(!response.data.call_status) {
                        reject('Response data error');
                    } else if (response.data.call_status === "OK") {
                        resolve(response.data.data);
                    } else {
                        reject(response.data.error);
                    }
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {

                });
        });
    },

    SaveGlobalLocation({ commit}, request_data ) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route('databases.save_global_location');
            this._vm.$axios.post(r, request_data)
                .then(response => {
                    if(!response.data.call_status) {
                        reject('Response data error');
                    } else if (response.data.call_status === "OK") {
                        resolve(response.data.data);
                    } else {
                        reject(response.data.error);
                    }
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {

                });
        });
    },

    RemoveGlobalLocation({ commit}, request_data ) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route('databases.remove_global_location');
            this._vm.$axios.post(r, request_data)
                .then(response => {
                    if(!response.data.call_status) {
                        reject('Response data error');
                    } else if (response.data.call_status === "OK") {
                        resolve(response.data.data);
                    } else {
                        reject(response.data.error);
                    }
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {

                });
        });
    },

    SaveDatabaseUser({ commit}, request_data ) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route('databases.save_database_user', {
                domain_id: request_data['domain_id'],
            });
            this._vm.$axios.post(r, request_data)
                .then(response => {
                    if(!response.data.call_status) {
                        reject('Response data error');
                    } else if (response.data.call_status === "OK") {
                        resolve(response.data.data);
                    } else {
                        reject(response.data.error);
                    }
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {

                });
        });
    },

    SavePrivileges({ commit}, request_data ) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route('databases.save_privileges');
            this._vm.$axios.post(r, request_data)
                .then(response => {
                    if(!response.data.call_status) {
                        reject('Response data error');
                    } else if (response.data.call_status === "OK") {
                        resolve(response.data.data);
                    } else {
                        reject(response.data.error);
                    }
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {

                });
        });
    },

    RemoveAssociation({ commit}, request_data ) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route('databases.delete_associations');
            this._vm.$axios.post(r, request_data)
                .then(response => {
                    if(!response.data.call_status) {
                        reject('Response data error');
                    } else if (response.data.call_status === "OK") {
                        resolve(response.data.data);
                    } else {
                        reject(response.data.error);
                    }
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {

                });
        });
    },

    DeleteUser({ commit}, request_data ) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route('databases.delete_user');
            this._vm.$axios.post(r, request_data)
                .then(response => {
                    if(!response.data.call_status) {
                        reject('Response data error');
                    } else if (response.data.call_status === "OK") {
                        resolve(response.data.data);
                    } else {
                        reject(response.data.error);
                    }
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {

                });
        });
    },

    DeleteDatabase({ commit}, request_data ) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route('databases.delete_database');
            this._vm.$axios.post(r, request_data)
                .then(response => {
                    if(!response.data.call_status) {
                        reject('Response data error');
                    } else if (response.data.call_status === "OK") {
                        resolve(response.data.data);
                    } else {
                        reject(response.data.error);
                    }
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {

                });
        });
    },

    ConnectInPMA({ commit}, request_data ) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route('databases.get_pma_sso_handle', {
                database_id: request_data['database_id'],
                user_id: request_data['user_id']
            });
            this._vm.$axios.get(r, request_data)
                .then(response => {
                    if(!response.data.call_status) {
                        reject('Response data error');
                    } else if (response.data.call_status === "OK") {
                        resolve(response.data.data);
                    } else {
                        reject(response.data.error);
                    }
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {

                });
        });
    },

    GetSSOLink({ commit}, request_data ) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route('databases.get_pma_sso_link', {
                sso_handle: request_data['sso_handle']
            });
            this._vm.$axios.get(r)
                .then(response => {
                    if(!response.data.call_status) {
                        reject('Response data error');
                    } else if (response.data.call_status === "OK") {
                        resolve(response.data.data);
                    } else {
                        reject(response.data.error);
                    }
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {

                });
        });
    },

    //----------------------------------

    getDbSystemsForDomain({ commit }, payload) {
        //commit("resetAvailableSystems");
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route("environments.get_db_systems", { domain_id: payload.domain_id });
            this._vm.$axios
                .get(r)
                .then((response) => {
                    if (response.data.call_status === "OK") {
                        //commit("addAvailableSystems", response.data.data.systems);
                        //commit("addSystemTypes", response.data.data.system_types);
                        resolve(response);
                    } else {
                        console.log("fm4vmi#63443235");
                        reject(response.data);
                    }
                })
                .catch((error) => {
                    console.log("fm4vmi#654386");
                    console.log(error.response);
                    reject(error);
                })
                .finally(() => {});
        });
    }

};

const mutations = {
    setDatabases(state, databases) {
        state.databases = databases;
    },
    setDatabaseUsers(state, database_users) {
        state.database_users = database_users;
    },
    setUsersToDatabasesLinks(state, users_to_databases_links) {
        state.users_to_databases_links = users_to_databases_links;
    },
    setDatabaseSystems(state, database_systems) {
        state.database_systems = database_systems;
    },
    setDatabaseGlobalLocations(state, database_global_locations) {
        state.database_global_locations = database_global_locations;
    },

    addDatabaseGlobalLocations(state, database_global_location) {
        state.database_global_locations.push(database_global_location);
    },

    addDatabase(state, database_data) {
        state.databases.unshift(database_data);
    },

    saveDatabaseGlobalLocation(state, database_global_location) {
        for(let i = 0; i < state.database_global_locations.length; i++)
        {
            if(state.database_global_locations[i].id === database_global_location.id)
            {
                this._vm.$set(state.database_global_locations[i], "name", database_global_location.name);
                this._vm.$set(state.database_global_locations[i], "ip", database_global_location.ip);

                break;
            }
        }
    },

    removeDatabaseGlobalLocation(state, location_id) {
        let remove_index = -1;
        for(let i = 0; i < state.database_global_locations.length; i++)
        {
            if(state.database_global_locations[i].id === location_id)
            {
                remove_index = i;

                break;
            }
        }

        if(remove_index >= 0)
        {
            state.database_global_locations.splice(remove_index, 1);
        }
    },

    addDatabaseUser(state, user_data) {
        state.database_users.push(user_data);
    },

    updateDatabaseUser(state, user_data) {
        let replace_index = -1;
        for(let i = 0; i < state.database_users.length; i++)
        {
            if(state.database_users[i].id === user_data.id)
            {
                replace_index = i;
                break;
            }
        }

        if(replace_index > -1)
        {
            state.database_users.splice(replace_index, 1, user_data);
        }
    },

    addUserToDatabaseLink(state, link_data) {
        state.users_to_databases_links.push(link_data);
    },

    updateUserToDatabaseLink(state, link_data) {
        let replace_index = -1;
        for(let i = 0; i < state.users_to_databases_links.length; i++)
        {
            if(state.users_to_databases_links[i].id === link_data.id)
            {
                replace_index = i;
                break;
            }
        }

        if(replace_index > -1)
        {
            state.users_to_databases_links.splice(replace_index, 1, link_data);
        }
    },

    removeUserToDatabaseLink(state, remove_data) {
        state.users_to_databases_links = state.users_to_databases_links.filter(
            user_to_database_link =>
                !(user_to_database_link.database_id === remove_data.database_id && user_to_database_link.database_user_id === remove_data.user_id)
        )
    },

    removeUserToDatabaseLinkIds(state, link_ids) {
        state.users_to_databases_links = state.users_to_databases_links.filter(
            user_to_database_link =>
                link_ids.indexOf(user_to_database_link.id) === -1
        )
    },

    removeUserId(state, user_id) {
        let delete_index = -1;
        for(let i = 0; i < state.database_users.length; i++)
        {
            if(state.database_users[i].id === user_id)
            {
                delete_index = i;
                break;
            }
        }

        if(delete_index > -1)
        {
            state.database_users.splice(delete_index, 1);
        }
    },

    removeDatabaseId(state, database_id) {
        let delete_index = -1;
        for(let i = 0; i < state.databases.length; i++)
        {
            if(state.databases[i].id === database_id)
            {
                delete_index = i;
                break;
            }
        }

        if(delete_index > -1)
        {
            state.databases.splice(delete_index, 1);
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
